import { PropsWithChildren } from 'react';

import { VerticalContainer } from '@/components';

type EditorSectionProps = PropsWithChildren<{
    scrollRef: React.RefObject<HTMLDivElement>;
}>;

export const EditorSection = ({ scrollRef, children }: EditorSectionProps) => {
    return (
        <section
            className="flex h-full flex-col overflow-y-auto pr-16"
            ref={scrollRef}
        >
            <VerticalContainer spacing="md" className="h-full" as="form">
                {children}
            </VerticalContainer>
        </section>
    );
};
